import CKEditorError from '@ckeditor/ckeditor5-utils/src/ckeditorerror';
import { findOptimalInsertionRange } from '@ckeditor/ckeditor5-widget/src/utils';

export function requireViewRange( editor, view, domEvent ) {
	const viewRange = getViewRange( editor.editing.view, domEvent );
	if (!viewRange) {
		throw new CKEditorError(
			'vjoonInsertContent: Cannot create range for view.',
			this
		);
	}
	return viewRange;
}

function getViewRange( view, domEvent ) {
	const domDoc = domEvent.target.ownerDocument;
	const x = domEvent.clientX;
	const y = domEvent.clientY;
	let domRange;

	// console.debug("domEvent");
	// console.debug(domEvent);
	if (domDoc.caretRangeFromPoint && domDoc.caretRangeFromPoint( x, y )) {
		// Webkit & Blink.
		domRange = domDoc.caretRangeFromPoint( x, y );
	} else if (domDoc.caretPositionFromPoint && domDoc.caretPositionFromPoint( x, y )) {
		// FF > 20.
		const caretPosition = domDoc.caretPositionFromPoint( x, y );
		console.debug( 'caretPosition' + caretPosition);
		domRange = domDoc.createRange();
		domRange.setStart( caretPosition.offsetNode, caretPosition.offset );
		domRange.collapse( true );
	} else if (domEvent.rangeParent) {
		// FF.
		console.debug( 'domEvent.rangeParent' );
		console.debug( domEvent.rangeParent );
		console.debug( 'domEvent.rangeOffset' );
		console.debug( domEvent.rangeOffset );
		domRange = domDoc.createRange();
		domRange.setStart( domEvent.rangeParent, domEvent.rangeOffset );
		domRange.collapse( true );
	}

	console.debug( 'domRange' );
	console.debug( domRange );
	if (domRange) {
		return view.domConverter.domRangeToView( domRange ) || getDefaultRange( view );
	} else {
		return getDefaultRange( view );
	}
}

function getDefaultRange( view ) {
	console.debug( 'vjoonInsertContent: Use first Range of document.' );
	return view.document.selection.getFirstRange();
}

export function insertContentToWriter( editor, writer, viewRange, content, useOptimalPosition = true ) {
	let modelToInsert = getModel( editor, content );

	let range = editor.editing.mapper.toModelRange( viewRange );
	if (useOptimalPosition) {
		range = findOptimalInsertionRange( writer.createSelection( range ), editor.model );
	}
	// TODO check if we can use `insertObject`
	editor.model.insertContent( modelToInsert, range );

	if (modelToInsert.parent) {
		writer.setSelection( modelToInsert, 'on' );
	}
}

function getModel( editor, content ) {
	let model;
	if (content && content.is) {
		if (content.is( 'view:documentFragment' ) || content.is( 'view:node' )) {
			model = editor.data.toModel( content );
		} else if (content.is( 'model:documentFragment' ) || content.is( 'model:node' )) {
			model = content;
		} else {
			model = editor.data.toModel( editor.data.processor.toView( content ) );
		}
	} else {
		model = editor.data.toModel( editor.data.processor.toView( content ) );
	}
	return model;
}
